import React from "react";
import { v4 } from "uuid";
import { Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { Info as InfoCircle } from "@material-ui/icons";
import { PaymentRow } from "./PaymentRow";

export const PaymentList = ({
  payments,
  title,
  info,
  noDataInfo,
  xs,
  item,
  container,
  ...rest
}) => {
  return (
    <Grid
      {...rest}
      xs={xs || 12}
      item={item || true}
      container={container || true}
    >
      {title && (
        <Grid item>
          <Typography variant="h5">{title}</Typography>
        </Grid>
      )}
      {info && payments.length > 0 && (
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <InfoCircle className="icon-sized icon-secondary" />
          </Grid>
          <Grid item>{info}</Grid>
        </Grid>
      )}

      <Grid container>
        {payments.length > 0 ? (
          payments.map(({ merchantName, amount, date, category }) => (
            <PaymentRow
              key={v4()}
              category={category}
              text={merchantName}
              price={amount}
              date={date}
            />
          ))
        ) : (
          <div className="info-no-data">{noDataInfo}</div>
        )}
      </Grid>
    </Grid>
  );
};

PaymentList.propTypes = {
  title: PropTypes.string,
  info: PropTypes.string,
  noDataInfo: PropTypes.string,
  payments: PropTypes.array,
  xs: PropTypes.number,
  item: PropTypes.bool,
  container: PropTypes.bool,
};

PaymentList.defaultProps = {
  title: null,
  info: null,
  noDataInfo: null,
  payments: [],
  xs: 12,
  item: true,
  container: true,
};

export default PaymentList;
